import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../../components/elements/form/input";
import Teaxtarea from "../../../../components/elements/form/textarea";
import SelectBox from "../../../../components/elements/form/selectBox";
import Datepicker from "../../../../components/elements/form/datepicker";
import Button from "../../../../components/elements/button";
import { useFacilitiesApi } from "../../../../store/api/hooks/facilitiesApiHook";
import toast from "react-hot-toast";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useFacilityManagersSelector } from "../../../../store/selectors/masterSelector";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";
import { useCycleCountApi } from "../../../../store/api/hooks/cycleCountApiHook";
import { getSelectedOption } from "../../../../_common/functions";
import Currency from "../../../../components/currency";
import moment from "moment";


interface Props {
	_ref?: any;
	editData?: any;
	onCreate?: () => void;
	onCancel?: () => void;
	partDetails?: any;
}
type FormValues = {
	cycleCountNotes: string;
	operatorID: any;
	assetType: string;
	purchaseDate: Date | null;
	facilityID: any;
	subFacilityID: any;
	isDraft: boolean;
};

const CreateCycleCount: React.FC<Props> = ({
	_ref,
	editData,
	onCreate = () => { },
	onCancel = () => { },
	partDetails
}) => {
	const [facilityoption, setFacilityoption] = useState<any>(null);
	const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
	const [cycleCountCode, setCycleCountCode] = useState<any>(null);
	const [partstatus, setPartStatus] = useState<boolean>(false);
	const [scanCode, setScanCode] = useState<string>('');
	const [parts, setParts] = useState<any>([]);
	const facilityApi: any = useFacilitiesApi();
	const commonApi: any = useCommonApi();
	const spearPartsAPI = useSpearPartsApi();
	const cycleCountAPI = useCycleCountApi();

	const {
		control,
		register,
		handleSubmit,
		setValue,
		reset,
		trigger,
		formState: { errors },
		watch,
	} = useForm<FormValues>({
		defaultValues: {
			isDraft: false,
			cycleCountNotes: ""
		}
	});
	const users = useFacilityManagersSelector();
	const facilityWatch = watch("facilityID");
	const subFacilityWatch =watch('subFacilityID');

	const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facilist: any) => {
					facilitylist.push({
						label: facilist.facilityName,
						value: facilist.facilityID,
						data: facilist,
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const getsubfacilityList = (_facilityID: any) => {
		const payload = { facilityID: _facilityID };
		facilityApi.getSubFacilityList(
			payload,
			(resp: any) => {
				let subfacilityoption: any = resp?.subFacilityList?.map(
					(countylist: any) => {
						return {
							label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
							value: countylist.subFacilityID,
						};
					}
				);
				setsubfacilityoption(subfacilityoption);

				if(editData){
					setValue("subFacilityID", getSelectedOption(editData?.subFacilityID, subfacilityoption));
				}

			},
			(error: any) => {
				console.log("error =>", error);
				setsubfacilityoption([]);
				toast.error(error);
			}
		);
	};

	const getCycleCountCode = () => {
		const payload = {};
		cycleCountAPI.GetID(
			payload,
			(resp: any) => {

				setCycleCountCode(resp.code);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		if (users == null) {
			commonApi.GetUserList(
				{
					pageNo: 1,
					pageSize: 1000,
				},
				(resp: any) => { },
				(error: any) => { }
			);
		}
	}, [users]);

	useEffect(() => {
		if (facilityWatch) {
			setValue("subFacilityID", null);
			getsubfacilityList(facilityWatch.value);
		}
	}, [facilityWatch]);

	const formReset = () => {
		reset({
			cycleCountNotes: '',
			operatorID: '',
			assetType: '',
			purchaseDate: null,
			facilityID: '',
			subFacilityID: ''

		});
		setParts([])
		setPartStatus(false)
		setSTOCKS([]);
		setSystemPartsCount([]);
	};

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
		}
	}, [_ref]);

	const onSubmit: SubmitHandler<FormValues> = (data) => {
	
		let cyclecnt: any = [];
		parts.map((part: any) => {

			cyclecnt.push({
				"partsID": part.partDetails.partsID,
				"systemQuantity": part.currentStock,
				"countedQuantity": Number(part.qty),
				"partsCostRate": part.avgUnitCost || part.partDetails.avgUnitCost || 0,
				"unitID": part.partDetails.unitID,
				"isDraft": false
			})

		})

		let payload:any = {
			"inventoryCycleCountCode": cycleCountCode,
			"operatorID": data.operatorID?.value,
			"facilityID": data.facilityID?.value,
			"subFacilityID": null,// data.subFacilityID?.value,
			"countingDate": data?.purchaseDate ? moment(data.purchaseDate).format('YYYY-MM-DD') : null,
			"cycleCountNotes": data.cycleCountNotes,
			"isDraft": !data.isDraft,
			"cycleCountDetails": cyclecnt
		}

		if(editData){
			payload.inventoryCycleCountID = editData?.inventoryCycleCountID
		}
	
		cycleCountAPI.Save(
			payload,
			(resp: any) => {
				onCreate();
				formReset();
				getCycleCountCode();
				toast.success("Cycle count Saved Successfully")
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		if (facilityoption) {
			console.log('facilityoption', facilityoption)
			if (!editData) {
				getCycleCountCode();
			} else {
				setPartStatus(true);
				setCycleCountCode(editData?.inventoryCycleCountCode);
				setValue("facilityID", getSelectedOption(editData?.facilityID, facilityoption ? facilityoption : []));
				setValue("purchaseDate", editData?.addedDate);
				setValue("operatorID", getSelectedOption(editData?.operatorID, users ? users : []));
				setValue("cycleCountNotes", editData?.cycleCountNotes);
				cycleCountAPI.GetByID({InventoryCycleCountID:editData.inventoryCycleCountID},(resp: any) => {
					setParts(resp?.cycleCountList.map((part: any) => {
						return {
							label: part?.partName  + ` (${part?.partsCode})`,
							value: part?.partsID,
							partDetails: {sparePartsName: part?.partName, partsCode: part?.partsCode, costPerUnit: part?.partsCostRate, unitID: part?.unitID, partsID: part?.partsID},
							currentStock: part?.systemQuantity,
							avgUnitCost: part?.avgUnitCost || 0,
							qty: part?.countedQuantity,
						}
					}))

					console.log("return resp--------", resp);
					//setParts(resp?.cycleCountDetails)
				}
				,(error: any) => {
					console.log("error =>", error);
					toast.error(error);
				});
				/* 
				cycl
				
				
				
				setParts(editData?.cycleCountDetails) */
			}
		}
		
	}, [editData, facilityoption]);

	useEffect(() => {
		getfacilitylist();
	}, []);

	const [STOCKS, setSTOCKS] = useState<any>([]);

	const GetStockInventoryBalanceReportList = () => {
        let payload: any = {
            pageSize: 0,
            pageNumber: 1,
            searchParam: '',
			facilityIDs: facilityWatch?.value || null,
        };

        spearPartsAPI.getCurrentStockDetails(payload, (resp: any) => {
            const stockReportList = resp.sparePartsStockReportList ?? [];
			console.log("stockReportList =>", stockReportList);
            setSTOCKS(stockReportList);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });

    };

	const addScanCode = (code:string) => {
		spearPartsAPI.getSpearPartsList(
			{
				pageSize: 20,
				pageNumber: 1,
				searchParam: code,
			},
			(data: any) => {
				if(data?.sparePartsList?.length > 0){
					let partOption = {
						label: data?.sparePartsList[0].sparePartsName + ` (${data?.sparePartsList[0].partsCode})`,
						value: data?.sparePartsList[0].partsID,
						partDetails: data?.sparePartsList[0],
					};

					cycleCountAPI.GetStockCount(
						{
							partID: partOption.value,
							facilityID: facilityWatch?.value,
							subFacilityID:subFacilityWatch?.value
						},
						(resp: any) => {
							let alreadyAdded = false;

							setParts(parts.map((part:any)=>{
								if(part.partDetails?.partsCode == partOption.partDetails?.partsCode){
									alreadyAdded = true
									return {...part,qty: Number(part.qty) + 1}
								} else {
									return part
								}
							}))
							if (!alreadyAdded) {
								const stockMatch = STOCKS.find((s: any) => s.partCode === partOption.partDetails?.partsCode);
								setParts([
									...parts,
									{
										...partOption,
										currentStock: stockMatch?.currentStock ?? resp?.currentStock ?? 0,
										avgUnitCost: resp?.avgUnitCost ?? partOption.partDetails?.avgUnitCost ?? 0,
										qty: 1
									},
								]);
							}
						},
						(error: any) => {
							const stockMatch = STOCKS.find((s: any) => s.partCode === partOption.partDetails?.partsCode);
							setParts([...parts, { ...partOption, currentStock: stockMatch?.currentStock ?? 0, avgUnitCost: partOption.partDetails?.avgUnitCost || 0 }]);
						}
					);
				} else {
					toast.error("No spare part found")
				}
			},
			(error: any) => {
				toast.error("No spare part found")
			}
		);
	}

	const [SystemPartsCount, setSystemPartsCount] = useState<any>([]);

	useEffect(() => {
		const newData:any = [];
		STOCKS.map((item: any) => {
			const alreadyCounting = parts.find((part: any) => part.partDetails?.partsCode == item.partCode);
			if(item.currentStock > 0 && !alreadyCounting){
				newData.push({...item, remainQuantity: item.currentStock});
			}
		})
		setSystemPartsCount(newData);
	}, [parts, STOCKS]);

	return (
		<div className="grid grid-cols-5 gap-2 h-full">
			<div className="h-full overflow-y-auto col-span-3">
				<form onSubmit={handleSubmit(onSubmit)} ref={_ref} >
					<div className="pt-4">
						<div className="bg-green-50 py-2 px-3">
							<h6 className="text-[0.813rem] font-semibold">Cycle Count Ref No</h6>
							<p className="text-[0.813rem] font-normal mt-2">{cycleCountCode}</p>
						</div>
						<div className="grid grid-cols-2 gap-2">
							<Controller
								name="facilityID"
								control={control}
								rules={{ required: "Facility is required" }}
								render={({ field: { value, onChange } }) => (
									<SelectBox
										label="Select Facility"
										value={value}
										disabled={partstatus}
										onChange={onChange}
										required
										placeholder="Choose Facility"
										options={facilityoption}
										className="mb-0"
										error={errors.facilityID?.message as any}
									/>
								)}
							/>
							{/* <Controller
						name="subFacilityID"
						control={control}
						//  rules={{ required: "SubFacility is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Select Sub Facility"
								value={value}
								disabled={partstatus}
								onChange={onChange}
								//   required
								placeholder="Choose Sub Facility"
								options={subfacilitylist}
								className="mb-0"
							/>
						)}
					/> */}
						</div>
					</div>
					<Controller
						name="purchaseDate"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Datepicker
								disabled={partstatus}
								label="Date"
								value={value}
								onChange={onChange}
								className="mt-3"
							/>
						)}
					/>
					<Controller
						name="operatorID"
						control={control}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Operator Name"
								value={value}
								onChange={onChange}
								disabled={partstatus}

								placeholder="Operator Name"
								options={users ? users : []}
							/>
						)}
					/>
					<Button disabled={partstatus} className="mt-3" type="button"
						onClick={() => {
							trigger(['facilityID']).then((valid: boolean) => {
								if (valid) {
									GetStockInventoryBalanceReportList();
									setPartStatus(true);
									if (partDetails) {
										addScanCode(partDetails.partsCode)
									}
								}
							})
						}}
					>
						Start
					</Button>
					{partstatus && (
						<>
							{!partDetails && (
								<div>
									<Input
										className="!my-0"
										type="text"
										value={scanCode}
										onChange={(e: any) => {
											setScanCode(e.target.value)
										}}
										placeholder="Enter Part Code"
										onKeyDown={(e: any) => {
											if (e.key === "Enter") {
												e.preventDefault();
												if (e.target.value) {
													addScanCode(e.target.value);
													setScanCode('')
												}
											}
										}}
									/>
									<div className="text-center mt-2 font-normal text-slate-500">OR</div>
									<SelectBox
										className="mt-2"
										async={true}
										value={null}
										onChange={(option) => {
											cycleCountAPI.GetStockCount(
												{
													partID: option.value,
													facilityID: facilityWatch?.value,
													subFacilityID: subFacilityWatch?.value
												},
												(resp: any) => {
													let alreadyAdded = false;

													setParts(parts.map((part: any) => {
														if (part.partDetails?.partsCode == option.partDetails?.partsCode) {
															alreadyAdded = true;
															return { ...part, qty: Number(part.qty) + 1 }
														} else {
															return part
														}
													}))
													if (!alreadyAdded) {
														const stockMatch = STOCKS.find((s: any) => s.partCode === option.partDetails?.partsCode);
														setParts([
															...parts,
															{
																...option,
																currentStock: stockMatch?.currentStock ?? resp?.currentStock ?? 0,
																avgUnitCost: resp?.avgUnitCost ?? option.partDetails?.avgUnitCost ?? 0,
																qty: 1
															},
														]);
													}
												},
												(error: any) => {
													const stockMatch = STOCKS.find((s: any) => s.partCode === option.partDetails?.partsCode);
													setParts([...parts, { ...option, currentStock: stockMatch?.currentStock ?? 0, avgUnitCost: option.partDetails?.avgUnitCost ?? 0 }]);
												}
											);
										}}
										placeholder="search part here"
										asyncLoadOptions={(value: string) => {
											return new Promise((resolve, reject) => {
												spearPartsAPI.getSpearPartsList(
													{
														pageSize: 20,
														pageNumber: 1,
														searchParam: value,
													},
													(data: any) => {
														// console.log("Part Data", data)
														resolve(
															data.sparePartsList.map((part: any) => {
																return {
																	label: part.sparePartsName + ` (${part.partsCode})`,
																	value: part.partsID,
																	partDetails: part,
																};
															})
														);
													},
													(error: any) => {
														reject(error);
													}
												);
											});
										}}
									/>
								</div>
							)}

							<div className="rounded-md border border-gray-300 mt-3">
								<div className="grid grid-cols-12 gap-1 bg-gray-100">
									<div className="col-span-2 px-2 leading-10 ">
										<label className="text-[0.75rem] font-medium text-slate-600">
											Part Code
										</label>
									</div>
									<div className="col-span-2 px-2 leading-10">
										<label className="text-[0.75rem] font-medium text-slate-600">
											Part Name
										</label>
									</div>
									<div className="col-span-2 px-2 leading-10">
										<label className="text-[0.75rem] font-medium text-slate-600">
											System Qty
										</label>
									</div>
									<div className="col-span-2 px-2 leading-10">
										<label className="text-[0.75rem] font-medium text-slate-600">
											Counted Qty
										</label>
									</div>
									<div className="col-span-2 px-2 leading-10">
										<label className="text-[0.75rem] font-medium text-slate-600">
											Avg Unit Cost
										</label>
									</div>
									<div className="col-span-2 px-2 leading-10">
										<label className="text-[0.75rem] font-medium text-slate-600">
											Adj. Cost
										</label>
									</div>
								</div>
								{parts.map((part: any, index: any) => {
									const adjQty = Number(part?.qty || 0) - Number(part?.currentStock || 0);
									const adjCost = adjQty * Number(part?.avgUnitCost || 0);
									const adjColor = adjCost > 0 ? 'text-green-600' : adjCost < 0 ? 'text-red-600' : 'text-slate-600';
									return (
									<div
										className="grid grid-cols-12 gap-1 text-slate-800"
										key={part.id}
									>
										<div className="col-span-2 px-2 leading-10 flex items-center">
											<label className="text-[0.75rem] font-normal">{part?.partDetails?.partsCode}</label>
										</div>
										<div className="col-span-2 px-2 leading-10 flex items-center">
											<label className="text-[0.75rem] font-normal">
												{part?.partDetails?.sparePartsName}
											</label>
										</div>
										<div className="col-span-2 px-2 leading-10 flex items-center">
											<label className="text-[0.75rem] font-normal text-center w-full">
												{part?.currentStock}
											</label>
										</div>
										<div className="col-span-2 px-2 leading-10 flex items-center">
											<Input
												size="sm"
												className="!my-0"
												type="number"
												value={part.qty}
												onChange={(e) => {
													const value = Number(e.target.value);
													if (value < 0) {
														toast.error("Value cannot be negative");
														return;
													}
													setParts(
														parts.map((_part: any) => {
															if (_part.value == part.value) {
																_part.qty = e.target.value;
															}
															return _part;
														})
													);
												}}
											/>
										</div>
										<div className="col-span-2 px-2 leading-10 flex items-center">
											<label className="text-[0.75rem] font-normal text-center w-full">
												{Number(part?.avgUnitCost || 0).toFixed(2)}
											</label>
										</div>
										<div className="col-span-2 px-2 leading-10 flex items-center">
											<label className={`text-[0.75rem] font-semibold text-center w-full ${adjColor}`}>
												<Currency currency="USD" value={adjCost.toFixed(2)} />
											</label>
										</div>
									</div>
									);
								})}
							</div>
						</>
					)}

					<Controller
						name="cycleCountNotes"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Teaxtarea
								label="Note"
								value={value}
								onChange={onChange}
								placeholder="Note"
							/>
						)}
					/>
					<Controller
						name="isDraft"
						control={control}
						render={({ field: { value, onChange } }) => (
							<div className="flex items-center gap-2 my-3">
								<input type="checkbox" checked={value} onChange={onChange} />
								<p>Save & perform stock adjustment</p>
							</div>
						)}
					/>
					<div className="flex justify-end gap-2">
						<Button type="submit" disabled={parts.length == 0 ? true : false}>
							Save
						</Button>
						<Button
							theme="secondary"
							onClick={() => {
								onCancel();
								formReset();
							}}
						>
							Cancel
						</Button>
					</div>
				</form>
			</div>
			<div className="h-full overflow-y-auto col-span-2">
				<h3 className="sticky top-0 bg-white py-2 z-10">Expected Quantity</h3>
				<div className="rounded-md border border-gray-300">
					<table className="w-full">
						<thead className="bg-gray-100 sticky top-8 z-10">
							<tr>
								<th className="px-2 leading-10 text-left">
									<label className="text-[0.75rem] font-medium text-slate-600">
										Part Code
									</label>
								</th>
								<th className="px-2 leading-10 text-left">
									<label className="text-[0.75rem] font-medium text-slate-600">
										Part Name
									</label>
								</th>
								<th className="px-2 leading-10 text-center">
									<label className="text-[0.75rem] font-medium text-slate-600">
										System Qty
									</label>
								</th>
							</tr>
						</thead>
						<tbody>
							{SystemPartsCount.map((part: any, index: any) => (
								<tr
									className="text-slate-800 border-t border-gray-200"
									key={'sys_' + part.partCode}
								>
									<td className="px-2 leading-10">
										{part?.partCode}
									</td>
									<td className="px-2 leading-10">
										<label className="text-[0.75rem] leading-none font-normal whitespace-nowrap truncate block" title={part?.partName}>
											{part?.partName}
										</label>
									</td>
									<td className="px-2 leading-10 text-center">
										<label className="text-[0.75rem] font-normal">
											{part?.remainQuantity}
										</label>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>

	);
};

export default CreateCycleCount;
